import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "ehrLabGridIsShow", true);
        Vue.set(state, "ehrLabFormIsShow", false);

        Vue.set(state, "ehrGridIsShow", true);
        Vue.set(state, "ehrFormIsShow", false);
    },
    showTable(state) {
        state.ehrGridIsShow = true;
        state.ehrFormIsShow = false;
        state.ehrCovidAntigenTestFormIsShow = false;
    },
    showForm(state) {
        state.ehrGridIsShow = false;
        state.ehrFormIsShow = true;
        state.ehrCovidAntigenTestFormIsShow = false;
    },
    showCovidRATForm(state) {
        state.ehrGridIsShow = false;
        state.ehrFormIsShow = false;
        state.ehrCovidAntigenTestFormIsShow = true;
    },

    showEHRLabTable(state) {
        state.ehrLabGridIsShow = true;
        state.ehrLabFormIsShow = false;
    },
    showEHRLabForm(state) {
        state.ehrLabGridIsShow = false;
        state.ehrLabFormIsShow = true;
    }
}
